"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetScopedContentService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const practice_sc_web_1 = require("@branch-ts/practice-sc-web");
const sc_consensus_1 = require("@branch-ts/sc-consensus");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetScopedContentService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetScopedContentService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetScopedContentService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        get editorKind() {
            return this.deps.VersetRequireLoginService.agreement.particulars.versetWebapp.verse.editorKind;
        }
        getMediator(option) {
            return seqop_consensus_1.MediatorRegistryMechanism.ensure({
                uri: option.uri,
            });
        }
        async initialize() {
            const vendor = this.me.app.vendor;
            (0, practice_sc_web_1.FatScopedContent)({
                editorKind: this.editorKind,
            });
            this.registerScopedContentMediator(vendor);
        }
        registerScopedContentMediator(vendor) {
            seqop_consensus_1.MediatorRegistryMechanism.register({
                name: `${vendor}+sc`,
                registry: (option) => {
                    const scopeInfo = sc_consensus_1.ScopedContentProtocol.ScopeURI.parse(option.uri);
                    if (!scopeInfo || scopeInfo.vendor !== vendor) {
                        return null;
                    }
                    const provider = new seqop_consensus_1.ReconnectingArbitratorProvider(async () => {
                        const [result, reason, ...errors] = await this.server.rpcs.VersetUserScopedContentService.getMyMainContentScopeProvider({});
                        if (reason || !result?.provider) {
                            throw new Error(reason || errors[0]?.message || "Failed to get scoped-content provider");
                        }
                        if (result.scopeURI !== option.uri) {
                            throw new Error(`Scoped-content scope is not available: ${option.uri}`);
                        }
                        return result.provider;
                    }, this.server.authorizedConnection);
                    return provider.own(new sc_consensus_1.ScopedContentMediator({
                        provider,
                        uri: option.uri,
                    }));
                },
            });
        }
    };
    return VersetScopedContentService = _classThis;
})();
exports.VersetScopedContentService = VersetScopedContentService;
